export default "__VITE_ASSET__TNZaggpe__"